export default __webpack_public_path__ + "static/media/008-circle-white.51b62373.svg";